export default __webpack_public_path__ + "static/c9022a3cba1ae7db63006b1e8612b26b.png";